import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import type { SvgIconComponent } from "@mui/icons-material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

export interface LandingStat {
  value: string;
  label: string;
}

export interface LandingFeature {
  icon: SvgIconComponent;
  title: string;
  description: string;
}

export const heroStats: LandingStat[] = [
  { value: "94%", label: "ocupacao media nos horarios de maior demanda" },
  { value: "35h", label: "reducao mensal em tarefas operacionais manuais" },
  {
    value: "3.2x",
    label: "mais velocidade no fechamento de reservas recorrentes",
  },
];

export const features: LandingFeature[] = [
  {
    icon: CalendarMonthRoundedIcon,
    title: "Agenda esportiva inteligente",
    description:
      "Visual unico para disponibilidade, encaixes e recorrencia por modalidade e quadra.",
  },
  {
    icon: PeopleAltOutlinedIcon,
    title: "Relacionamento com mensalistas",
    description:
      "Historico completo de atendimento, presenca e recorrencia para retencao ativa.",
  },
  {
    icon: AccountBalanceWalletOutlinedIcon,
    title: "Financeiro integrado a operacao",
    description:
      "Cobrancas, inadimplencia e repasses conectados diretamente ao calendario esportivo.",
  },
  {
    icon: InsightsRoundedIcon,
    title: "Metricas para decisoes rapidas",
    description:
      "Painel executivo com receita, ocupacao e evolucao para gestao orientada por dados.",
  },
  {
    icon: AutorenewRoundedIcon,
    title: "Recorrencia em escala",
    description:
      "Automatize ciclos de reserva para previsibilidade de receita e fidelizacao continua.",
  },
  {
    icon: ShieldOutlinedIcon,
    title: "Governanca e controle",
    description:
      "Permissoes, rastreabilidade e seguranca com padrao profissional para sua equipe.",
  },
];

export const agendaHighlights: string[] = [
  "Disponibilidade multiquadra com leitura instantanea por horario.",
  "Regras de bloqueio, excecoes e recorrencia no mesmo fluxo operacional.",
  "Sincronizacao entre recepcao, comercial e coordenacao esportiva.",
];

export const growthHighlights: string[] = [
  "Visao de retencao e frequencia dos mensalistas em tempo real.",
  "Comparativos por periodo, modalidade e quadra para decisoes comerciais.",
  "Base previsivel para expansao com qualidade de servico e margem saudavel.",
];

export const lottieSources = {
  hero: "https://assets-v2.lottiefiles.com/a/9c215ae6-1182-11ee-8410-9f6ae85fb165/CbYs7uv0pL.json",
  agenda:
    "https://assets-v2.lottiefiles.com/a/985752d4-1183-11ee-bf19-a3d64b0cb0b3/egsRucqqEs.json",
  growth:
    "https://assets-v2.lottiefiles.com/a/98585b66-1183-11ee-bf1a-17080f536443/Jhd1OeFpvd.json",
};
